// extracted by mini-css-extract-plugin
module.exports = {"editValue":"InlineTextEditor_editValue__2UXwF"};